module.exports = __webpack_public_path__ + "img/warning_p.8bfb3cf3.svg";